import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DataDoraService} from '../../utils/data-services/data-dora.service';
import {MatDialog} from '@angular/material/dialog';
import {AddBySelectDialogComponent} from './add-by-select-dialog/add-by-select-dialog.component';
import swal from 'sweetalert2';
import {DataConcessionService} from "../../utils/data-services/dataConcession.service";
import {DataCreationConcessionService} from "../../utils/data-services/dataCreation-concession.service";

@Component({
  selector: 'app-modification-concession-dora',
  templateUrl: './modification-concession-dora.component.html',
  styleUrls: ['./modification-concession-dora.component.scss']
})
export class ModificationConcessionDoraComponent implements OnInit {

  id = null;
  concession = null;
  projects = [];
  brands = [];
  allBrands = [];

  constructor(
    private activeRoute: ActivatedRoute,
    private dataDoraService: DataDoraService,
    private route: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.id = Number(this.activeRoute.snapshot.paramMap.get('id'));
    this.getData();
    this.getAllBrands();
  }
  getData(): any {
    this.dataDoraService.getDealershipById(this.id).subscribe(res => {
      this.concession = res.concession;
      this.concession.projects.sort((a, b) => {return a > b ? 1 : -1});
      this.projects = res.projects;
      this.brands = res.brands;
    });
  }
  getAllBrands() {
    this.dataDoraService.getBrands().subscribe(res => {
      this.allBrands = res;
    });
  }
  onOpenDialogSelect(type): any {
    const dialogRef = this.dialog.open(AddBySelectDialogComponent, {
      data: {
        type: type == 'project' ? 'Projets' : 'Marques',
        values: type == 'project' ? this.projects : this.brands,
        dealership: this.id
      },
      autoFocus: true,
      minWidth: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'success') {
        this.getData();
      }
    });
  }
  deleteDealershipBrand(brandName: string): void {
    const brand = this.allBrands.find((b: any) => b.libelle_marque == brandName);
    swal.fire({
      title: 'Supprimer',
      text: 'Voulez-vous supprimer cette marque de la concession',
      confirmButtonText: 'Ok',
      showCancelButton: true,
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (!result.dismiss) {
        this.dataDoraService.deleteDealershipBrand(this.id, Number(brand.id_marque)).subscribe(res => {
          if (res == 'Data successfully delete.') {
            swal.fire({
              title: 'Succès!',
              text: 'La marque a bien été supprimer de la concession.',
              type: 'success',
              confirmButtonText: 'Ok'
            });
          } else {
            swal.fire({
              title: 'Erreur!',
              text: 'Une erreur est surnevue lors de la suppression de la marque.',
              type: 'error',
              confirmButtonText: 'Ok'
            });
          }
          this.getData();
        });
      }
    });
  }
}
